export default "__VITE_ASSET__BFXelG61__"